import { render, staticRenderFns } from "./BannersAdsStats.vue?vue&type=template&id=6923be98&scoped=true"
import script from "./BannersAdsStats.vue?vue&type=script&scoped=true&lang=js"
export * from "./BannersAdsStats.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./BannersAdsStats.vue?vue&type=style&index=0&id=6923be98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923be98",
  null
  
)

export default component.exports